import { render, staticRenderFns } from "./HeaderComp.vue?vue&type=template&id=ebb12f6a&scoped=true&"
import script from "./HeaderComp.vue?vue&type=script&lang=js&"
export * from "./HeaderComp.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComp.vue?vue&type=style&index=0&id=ebb12f6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb12f6a",
  null
  
)

export default component.exports